import React from 'react';

interface ErrorMessageProps {
  position?: string;
}
const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, position }) => (
  <span
    style={{
      color: 'red',
      fontSize: '0.875rem',
      lineHeight: 1.43,
      ...(position ? { position: position as React.CSSProperties['position'] } : {}),
    }}
  >
    {children}
  </span>
);

ErrorMessage.defaultProps = {
  position: 'static',
};

export default ErrorMessage;
